import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const FormWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,.1);
  margin-top: 16px;
`

export const FormItemWrapper = styled.div`
  padding: 16px 24px;
  width: 50%;
  ${({ right }) => right
    ? 'border-left: 1px solid rgba(0,0,0,.1);'
    : ''}

  .white-disable {
    background-color: #fff;
    color: #000;
  }
`

export const TwoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  > div {
    width: 50%;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`
